import { FormikHelpers, FormikValues } from 'formik';
import React, { useState } from 'react';
import { object, string } from 'yup';

import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import { FechamentoDeFolhaUploadLista } from 'Component/FechamentoDeFolha';
import Form, { Campo } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import { useRecuperarVinculosEmpregaticiosQuery } from 'View/Service/Default/VinculosEmpregaticios';

const regras = object({
  inicio: string().required('Obrigatório'),
  termino: string().required('Obrigatório'),
});

const Default = (): React.ReactElement => {
  const [inicio, setInicio] = useState<string>();
  const [termino, setTermino] = useState<string>();

  const {
    data: { vinculos } = {},
    isFetching,
    isLoading,
  } = useRecuperarVinculosEmpregaticiosQuery(
    {
      finder: 'fechamentoDeFolha',
      contain: ['Usuarios', 'Empresas', 'Funcoes'],
      limit: 200,
      options: { status: 1 },
    },
    {
      skip: !inicio || !termino,
    }
  );

  const filtrar = (
    dados: { inicio: string; termino: string },
    form: FormikHelpers<FormikValues>
  ) => {
    setInicio(dados.inicio);
    setTermino(dados.termino);

    form.setSubmitting(false);
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Fechamento de folha em lote"
        descricao="Importe em lote o fechamento de folha dos funcionários"
      />
      <Form
        emLinha
        onSubmit={filtrar}
        regras={regras}
        desabilitado={isFetching}
      >
        <div className="row justify-content-center">
          <div className="col-md-6 mb-3">
            <div className="hstack gap-3">
              <Campo name="inicio" type="date" />
              <Campo name="termino" type="date" />
              <Botao type="submit" icone="filter" />
              <BotaoLink to="/fechamentos-de-folha/relatorios" tema="success">
                Relatórios
              </BotaoLink>
            </div>
          </div>
        </div>
      </Form>
      <Buscando exibir={isLoading} />
      <React.Fragment>
        {inicio && termino && (
          <div className="bg-white shadow-sm rounded table-responsive">
            <table className="table table-striped align-middle table-sm mb-0">
              <thead>
                <tr>
                  <th className="text-nowrap">Empresa</th>
                  <th className="text-nowrap">Funcionário</th>
                  <th className="text-nowrap">Função</th>
                  <th className="text-nowrap">Salário</th>
                  <th className="text-nowrap">Comissão</th>
                  <th className="text-nowrap">Ajuda de custo/Combustivel/Reembolso</th>
                  <th className="text-nowrap">Prêmio de metas - vendedores</th>
                  <th className="text-nowrap">Prêmio de metas - geral</th>
                  <th className="text-nowrap">Vale transporte</th>
                  <th className="text-nowrap">Vale adiantamento</th>
                  <th className="text-nowrap">Con. farmacia</th>
                  <th className="text-nowrap">Con. médico</th>
                  <th className="text-nowrap">Con. odonto</th>
                  <th className="text-nowrap">Emprestimo consignado</th>
                  <th className="text-nowrap">Outros descontos</th>
                  <th className="text-nowrap">Observação</th>
                  <th className="text-nowrap">--</th>
                </tr>
              </thead>
              <tbody>
                {vinculos?.map((folha) => (
                  <FechamentoDeFolhaUploadLista
                    key={`${folha.id}-${folha.modificado}`}
                    dados={folha}
                    inicio={inicio}
                    termino={termino}
                  />
                ))}
              </tbody>
            </table>
          </div>
        )}
      </React.Fragment>
    </LayoutDefault>
  );
};

export default Default;
